import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotFaceHappy = ({
    spotColor = "#1AD3B2",
    color = "#13126C",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" {...props}>
        <defs>
            <path id="face_teal_happy_svg__a" d="M0 0h37v37H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="face_teal_happy_svg__b" fill="#fff">
                <use xlinkHref="#face_teal_happy_svg__a" />
            </mask>
            <path
                fill={spotColor}
                d="M1 18.5C1 28.15 8.85 36 18.5 36S36 28.15 36 18.5 28.15 1 18.5 1 1 8.85 1 18.5Z"
                mask="url(#face_teal_happy_svg__b)"
                opacity={0.5}
            />
            <path
                fill={color}
                d="M18.5 0C28.7 0 37 8.3 37 18.5S28.701 37 18.5 37 0 28.7 0 18.5 8.299 0 18.5 0Zm0 1.516C9.135 1.516 1.516 9.135 1.516 18.5c0 9.365 7.619 16.984 16.984 16.984 9.365 0 16.984-7.619 16.984-16.984 0-9.365-7.619-16.984-16.984-16.984ZM12.682 11.98c1.195 0 2.122.463 2.661 1.383a.828.828 0 0 1-1.365.93l-.063-.094c-.222-.378-.593-.564-1.233-.564-.582 0-.942.153-1.17.466l-.064.098a.828.828 0 1 1-1.428-.836c.539-.92 1.466-1.383 2.662-1.383Zm12.658 0c1.195 0 2.122.463 2.661 1.383a.828.828 0 0 1-1.365.93l-.063-.094c-.222-.378-.593-.564-1.233-.564-.582 0-.942.153-1.17.466l-.064.098a.828.828 0 1 1-1.428-.836c.539-.92 1.466-1.383 2.662-1.383Z"
                mask="url(#face_teal_happy_svg__b)"
            />
            <path
                fill={color}
                fillRule="nonzero"
                d="M28 21.25H10.214a.96.96 0 0 0-.96.978c.164 4.237 4.508 7.522 9.746 7.522 5.35 0 9.75-3.423 9.75-7.75a.75.75 0 0 0-.75-.75Zm-.811 1.5-.008.055C26.66 25.842 23.224 28.25 19 28.25l-.28-.004c-4.089-.103-7.394-2.469-7.902-5.444l-.009-.052h16.38Z"
                mask="url(#face_teal_happy_svg__b)"
            />
        </g>
    </SVG>
);

SpotFaceHappy.displayName = "SpotFaceHappy";
